// Front-end mirror of the backend starter_templates catalog. Keep IDs in sync
// with backend/starter_templates.py — the API uses these IDs as the lookup key.

export const STARTER_TEMPLATES = [
  {
    id: "rest-api",
    title: "REST API Starter",
    short: "Three-tier REST API starter for review and customization.",
    description:
      "A classic three-tier REST API: an entry point with routing, auto-scaling compute, a managed relational database, and a caching layer. Battle-tested for most CRUD apps.",
    nodeCount: 9,
    bullets: [
      "Auto-scaling compute behind a load balancer",
      "Managed PostgreSQL with automated backups",
      "Redis cache for sessions & hot reads",
      "Object storage, secrets, and monitoring",
    ],
    accent: "#0EA5E9",
  },
  {
    id: "ecommerce",
    title: "E-Commerce Stack",
    short: "Scalable store with search and inventory.",
    description:
      "A storefront with a containerized application tier, a transactional catalog/orders database, cart and session caching, asynchronous order processing, and analytics. Built for traffic spikes and transactional reliability.",
    nodeCount: 12,
    bullets: [
      "WAF + global edge to absorb bot/DDoS traffic",
      "Container-orchestrated storefront with zero-downtime deploys",
      "Async order processing via event bus + queue + functions",
      "Analytics warehouse for sales & behavior",
    ],
    accent: "#5B5BD6",
  },
  {
    id: "serverless-pipeline",
    title: "Serverless Pipeline",
    short: "Event-driven data processing workflow.",
    description:
      "An event-driven data pipeline with no servers to manage. Data lands, flows through staged functions buffered by a queue, is orchestrated end-to-end, and results are stored and queryable. Scales to zero when idle.",
    nodeCount: 11,
    bullets: [
      "Multi-mode ingestion: API, streaming, and batch landing",
      "Stateless functions buffered by a queue for retries",
      "Stateful orchestration across pipeline stages",
      "Serverless SQL queries on processed data — no idle cost",
    ],
    accent: "#22C55E",
  },
];

export function getTemplate(id) {
  return STARTER_TEMPLATES.find((t) => t.id === id) || null;
}
